import * as React from 'react';
import { connect } from 'react-redux';
import { fetchExportarSellersApi } from '../../../api/axios';
import { Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { base64ToArrayBufferXlsx, saveByteArrayXlsx } from '../../../utilities/formatFile';

class ExportarSellers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hideSpinner: true
    }
  }

  busquedaParaDescargarExcel = () => {

    this.setState({ hideSpinner: false });
    this.requestParaExportar({});
  }

  requestParaExportar = async (request) => {
          
    let req = null;

    try {
      req = await fetchExportarSellersApi(request);
    } catch (e) {
      toast.error('No se pudieron descargar los sellers');
      return
    }

      const blob = base64ToArrayBufferXlsx(req.excelBytes);
      saveByteArrayXlsx("Sellers.xlsx", blob);
      this.setState({ hideSpinner: true });
  }

  render() {

    return (
      
      <div>
        <div className="row page-titles">

          <div className="col-md-8 align-self-center">
            <h4 className="text-themecolor color-rojo-megatone">Sellers</h4>
          </div>

          <div className="col-md-2 button-group align-self-center text-right d-none d-md-block">
            <Spinner hidden={ this.state.hideSpinner } animation="border" variant="secondary" size="sm-centrado" role="status" className="excel-spinner">
              <span className="sr-only">Loading...</span>
            </Spinner>
          </div>

          <div className="col-md-2 button-group align-self-center text-right d-none d-md-block">
              
              <button 
                type="button" 
                onClick={this.busquedaParaDescargarExcel} 
                className="btn btn-sm btn-green" 
                disabled={false}
              >
                Descargar sellers
              </button>

          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  tipoUsuario: state.general.tipoUsuario,
  idSeller: state.general.idSeller,
});

export default connect(mapStateToProps, {})(ExportarSellers);